/* Le Mur des rêves — DailyLama
   Filtres par style (client), fiche en surimpression clonée depuis la tuile (jamais d'innerHTML
   sur du contenu externe : la fiche est un <template> rendu par Liquid), navigation clavier,
   partage du lien. Aucun appel réseau, aucun suivi : pas de concours pour l'instant. */
(function () {
  'use strict';
  if (typeof window === 'undefined' || window.DailyLamaMur) return;

  function init(root) {
    var tuiles = Array.prototype.slice.call(root.querySelectorAll('[data-dlm-tuile]'));
    var compte = root.querySelector('[data-dlm-compte]');
    var aucun = root.querySelector('[data-dlm-aucun]');

    /* Filtres */
    Array.prototype.forEach.call(root.querySelectorAll('[data-dlm-filtre]'), function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-dlm-filtre') || '';
        Array.prototype.forEach.call(root.querySelectorAll('[data-dlm-filtre]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var n = 0;
        tuiles.forEach(function (t) {
          var ok = !f || t.getAttribute('data-style') === f;
          t.classList.toggle('is-cache', !ok);
          if (ok) n++;
        });
        if (compte) compte.textContent = n + (n > 1 ? ' rêves' : ' rêve');
        if (aucun) aucun.classList.toggle('dlm-hidden', n > 0);
      });
    });

    /* Mosaïque : hauteur de chaque tuile d'après son format (ratio), traduite en rangées de 8 px. */
    var grille = root.querySelector('[data-dlm-grille]');
    function caler() {
      if (!grille) return;
      var pas = 8, ecart = parseFloat(getComputedStyle(grille).rowGap) || 0;
      grille.classList.remove('is-mosaique');
      var hauteurs = tuiles.map(function (t) { return t.classList.contains('is-cache') ? 0 : t.getBoundingClientRect().height; });
      grille.classList.add('is-mosaique');
      tuiles.forEach(function (t, i) { if (hauteurs[i]) { t.style.height = Math.round(hauteurs[i]) + 'px'; t.style.gridRowEnd = 'span ' + Math.ceil((hauteurs[i] + ecart) / (pas + ecart)); } });
    }
    if (grille && 'ResizeObserver' in window) {
      var attente = null;
      new ResizeObserver(function () { clearTimeout(attente); attente = setTimeout(caler, 60); }).observe(grille);
    }
    caler();
    root.addEventListener('click', function (ev) { if (ev.target.closest && ev.target.closest('[data-dlm-filtre]')) setTimeout(caler, 0); });

    /* Surimpression */
    var fond = root.querySelector('[data-dlm-fond]');
    if (!fond) return;
    var sheet = fond.querySelector('[data-dlm-sheet]');
    var img = fond.querySelector('[data-dlm-sheet-img]');
    var titre = fond.querySelector('[data-dlm-sheet-titre]');
    var fiche = fond.querySelector('[data-dlm-sheet-fiche]');
    var copie = fond.querySelector('[data-dlm-copie]');
    var courant = -1, dernierFocus = null;

    function visibles() { return tuiles.filter(function (t) { return !t.classList.contains('is-cache'); }); }

    function ouvrir(t) {
      var liste = visibles(); courant = liste.indexOf(t);
      var source = t.querySelector('img');
      var gabarit = t.querySelector('[data-dlm-fiche]');
      img.src = source ? (source.currentSrc || source.src) : '';
      img.alt = source ? source.alt : '';
      titre.textContent = t.getAttribute('data-titre') || '';
      while (fiche.firstChild) fiche.removeChild(fiche.firstChild);
      if (gabarit && gabarit.content) fiche.appendChild(gabarit.content.cloneNode(true));
      var url = t.getAttribute('data-url') || '';
      var sig = fond.querySelector('[data-dlm-signaler]'), ret = fond.querySelector('[data-dlm-retrait]');
      if (sig) sig.href = sig.href.split('&body=')[0] + '&body=' + encodeURIComponent('Rêve : ' + titre.textContent + '\n' + location.origin + url);
      if (ret) ret.href = ret.href.split('&body=')[0] + '&body=' + encodeURIComponent('Rêve : ' + titre.textContent + '\n' + location.origin + url);
      if (copie) copie.textContent = '';
      fond.classList.remove('dlm-hidden'); root.classList.add('is-ouvert');
      document.documentElement.style.overflow = 'hidden';
      try { history.replaceState(null, '', '#' + url.split('/').pop()); } catch (e) {}
      titre.focus({ preventScroll: true });
    }
    function fermer() {
      fond.classList.add('dlm-hidden'); root.classList.remove('is-ouvert');
      document.documentElement.style.overflow = '';
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      if (dernierFocus && dernierFocus.focus) dernierFocus.focus({ preventScroll: true });
    }
    function voisin(delta) {
      var liste = visibles(); if (!liste.length) return;
      var i = (courant + delta + liste.length) % liste.length; ouvrir(liste[i]);
    }

    tuiles.forEach(function (t) {
      var lien = t.querySelector('[data-dlm-ouvrir]');
      if (!lien) return;
      lien.addEventListener('click', function (ev) {
        /* Clic modifié ou molette : on laisse la page article s'ouvrir normalement. */
        if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button === 1) return;
        ev.preventDefault(); dernierFocus = lien; ouvrir(t);
      });
    });
    fond.querySelector('[data-dlm-fermer]').addEventListener('click', fermer);
    fond.querySelector('[data-dlm-prec]').addEventListener('click', function () { voisin(-1); });
    fond.querySelector('[data-dlm-suiv]').addEventListener('click', function () { voisin(1); });
    fond.addEventListener('click', function (ev) { if (ev.target === fond) fermer(); });
    document.addEventListener('keydown', function (ev) {
      if (fond.classList.contains('dlm-hidden')) return;
      if (ev.key === 'Escape') fermer();
      else if (ev.key === 'ArrowLeft') voisin(-1);
      else if (ev.key === 'ArrowRight') voisin(1);
      else if (ev.key === 'Tab') {
        /* Le focus reste dans la fiche. */
        var f = sheet.querySelectorAll('a[href], button, [tabindex="-1"]');
        var premier = f[0], dernier = f[f.length - 1];
        if (ev.shiftKey && document.activeElement === premier) { ev.preventDefault(); dernier.focus(); }
        else if (!ev.shiftKey && document.activeElement === dernier) { ev.preventDefault(); premier.focus(); }
      }
    });
    var partager = fond.querySelector('[data-dlm-partager]');
    if (partager) partager.addEventListener('click', function () {
      var liste = visibles(); var t = liste[courant]; if (!t) return;
      var url = location.origin + (t.getAttribute('data-url') || '');
      var fini = function () { if (copie) copie.textContent = 'Lien copié'; };
      if (navigator.share) { navigator.share({ title: titre.textContent, url: url }).catch(function () {}); return; }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(fini, function () { if (copie) copie.textContent = url; });
      else if (copie) copie.textContent = url;
    });

    /* Lien profond : #handle ouvre la fiche correspondante. */
    if (location.hash.length > 1) {
      var h = location.hash.slice(1);
      var cible = tuiles.filter(function (t) { return (t.getAttribute('data-url') || '').split('/').pop() === h; })[0];
      if (cible) ouvrir(cible);
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-dlm-mur]'), function (r) { if (r.getAttribute('data-dlm-monte') !== '1') { r.setAttribute('data-dlm-monte', '1'); init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.DailyLamaMur = { boot: boot };
})();
